import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  MagnifyingGlassIcon,
  HeartIcon,
  BriefcaseIcon,
  ChatBubbleLeftRightIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import {
  MagnifyingGlassIcon as MagnifyingGlassIconSolid,
  HeartIcon as HeartIconSolid,
  BriefcaseIcon as BriefcaseIconSolid,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid,
  UserIcon as UserIconSolid
} from '@heroicons/react/24/solid';

const HomepageBottomNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleMyPageClick = (e) => {
    e.preventDefault();
    if (!user) {
      // 未登録ユーザーの場合、アカウント作成選択ページに遷移
      navigate('/register/type');
    } else {
      navigate('/mypage');
    }
  };

  const handleProtectedNavigation = (path) => {
    if (!user) {
      navigate('/register/type');
    } else {
      navigate(path);
    }
  };

  const isActive = (item) => {
    // マイページのタブの場合は特別処理
    if (item.id === 'favorites') {
      return location.pathname === '/mypage' && location.search.includes('tab=favorites');
    }
    if (item.id === 'mypage') {
      return location.pathname === '/mypage' && !location.search.includes('tab=favorites');
    }

    // その他のパス
    return item.activePaths.some(path => location.pathname.startsWith(path));
  };

  const navItems = [
    {
      id: 'search',
      label: 'さがす',
      path: user ? '/mobile-search' : '/register/type',
      icon: MagnifyingGlassIcon,
      activeIcon: MagnifyingGlassIconSolid,
      activePaths: ['/mobile-search', '/jobs', '/area-search'],
      onClick: null
    },
    {
      id: 'favorites',
      label: 'おきにいり',
      path: '/mypage?tab=favorites',
      icon: HeartIcon,
      activeIcon: HeartIconSolid,
      activePaths: ['/mypage'],
      onClick: () => handleProtectedNavigation('/mypage?tab=favorites')
    },
    {
      id: 'work',
      label: 'はたらく',
      path: '/work',
      icon: BriefcaseIcon,
      activeIcon: BriefcaseIconSolid,
      activePaths: ['/work', '/work/upcoming', '/work/history', '/work/biters'],
      onClick: () => handleProtectedNavigation('/work')
    },
    {
      id: 'messages',
      label: 'メッセージ',
      path: '/chat',
      icon: ChatBubbleLeftRightIcon,
      activeIcon: ChatBubbleLeftRightIconSolid,
      activePaths: ['/chat'],
      onClick: () => handleProtectedNavigation('/chat')
    },
    {
      id: 'mypage',
      label: 'マイページ',
      path: '/mypage',
      icon: UserIcon,
      activeIcon: UserIconSolid,
      activePaths: ['/mypage', '/profile', '/wallet-management', '/identity-verification'],
      onClick: handleMyPageClick
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
      <div className="flex items-center justify-around h-16 max-w-md mx-auto px-2">
        {navItems.map((item) => {
          const active = isActive(item);
          const Icon = active ? item.activeIcon : item.icon;

          if (item.onClick) {
            return (
              <button
                key={item.id}
                onClick={item.onClick}
                aria-label={item.label}
                className={`flex flex-col items-center justify-center flex-1 h-full px-1 py-2 transition-colors ${active
                    ? 'text-blue-600'
                    : 'text-gray-500 hover:text-gray-700 active:text-blue-500'
                  }`}
              >
                <Icon className="w-6 h-6 mb-1" />
                <span className="text-xs font-medium leading-none">
                  {item.label}
                </span>
              </button>
            );
          }

          return (
            <Link
              key={item.id}
              to={item.path}
              aria-label={item.label}
              className={`flex flex-col items-center justify-center flex-1 h-full px-1 py-2 transition-colors ${active
                  ? 'text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 active:text-blue-500'
                }`}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-xs font-medium leading-none">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default HomepageBottomNavigation;